export default "__VITE_ASSET__BGks7pm1__"